module.exports = __webpack_public_path__ + "static/media/9_l_stol_0_68.52.bc57a0ae.png";